import { render, staticRenderFns } from "./PageBookingAudience.vue?vue&type=template&id=476f05a5&"
import script from "./PageBookingAudience.vue?vue&type=script&lang=js&"
export * from "./PageBookingAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports